
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    usePhotoIcon: {
      type: Boolean,
      default: false,
    },
  },
});
